<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Puzzle-Loop-Generator-Root',
};
</script>
